import { Injectable, isDevMode } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import * as Sentry from '@sentry/browser';
import { LeadReferrer } from '../shared/lead-referrer';
import { LeadReferrerString, DefaultLeadReferrerString } from '../shared/lead-referrer-string';

@Injectable({
  providedIn: 'root'
})
export class LeadReferrerService {
  leadReferrer: LeadReferrer;
  leadReferrerString: LeadReferrerString;
  clickId: string;
  cookieDomain: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private cookieService: CookieService
  ) {
    let splitHost = window.location.hostname.split('.');
    this.cookieDomain = splitHost.length > 1
      ? splitHost[splitHost.length - 2] + '.' + splitHost[splitHost.length - 1]
      : window.location.hostname;
  }

  setReferrer() {
    if (!this.cookieService.check('lead_referrer') && !this.cookieService.check('fruRemoveCookies')) {
      const params = this.route.snapshot.queryParams;
      const source = this.scalarParam(params['utm_source']);
      const utm_content = source === 's2'
        ? this.scalarParam(params['transaction_id'])
        : '';

      this.leadReferrer = {
        source,
        medium: this.scalarParam(params['utm_medium']),
        campaign: this.scalarParam(params['utm_campaign']),
        keyword: this.scalarParam(params['utm_keyword']),
        content: this.scalarParam(params['utm_content']) || utm_content,
        network: this.scalarParam(params['network']),
        placement: this.scalarParam(params['placement']),
        gclid: this.scalarParam(params['gclid']),
        clickid: this.scalarParam(params['msclkid']),
        ttclid: this.scalarParam(params['ttclid']),
        tt_test_id: this.scalarParam(params['tt_test_id']),
        oppref: this.scalarParam(params['oppref']),
      }

      if (isDevMode()) {
        console.log('setting referrer', this.leadReferrer);
      }

      let d = new Date();
      d.setDate(d.getDate() + 1);

      this.cookieService.set('lead_referrer', JSON.stringify(this.leadReferrer), d, '/', this.cookieDomain);
    } else {
      let cookie = this.cookieService.get('lead_referrer');
      let cookieParsed;

      try {
        cookieParsed = JSON.parse(cookie);
      } catch (e) {
        cookieParsed = {};
      }

      this.leadReferrer = {
        source: this.scalarParam(cookieParsed.source),
        medium: this.scalarParam(cookieParsed.medium),
        campaign: this.scalarParam(cookieParsed.campaign),
        keyword: this.scalarParam(cookieParsed.keyword),
        content: this.scalarParam(cookieParsed.content),
        network: this.scalarParam(cookieParsed.network),
        placement: this.scalarParam(cookieParsed.placement),
        gclid: this.scalarParam(cookieParsed.gclid),
        clickid: this.scalarParam(cookieParsed.clickid),
        ttclid: this.scalarParam(cookieParsed.ttclid),
        tt_test_id: this.scalarParam(cookieParsed.tt_test_id),
        oppref: this.scalarParam(cookieParsed.oppref),
      }
    }

    if (!this.cookieService.check('lead_referrer_string') && !this.cookieService.check('fruRemoveCookies')) {
      this.leadReferrerString = DefaultLeadReferrerString;
      let d = new Date();
      d.setDate(d.getDate() + 1);
      this.cookieService.set('lead_referrer_string', JSON.stringify(this.leadReferrerString), d, '/', this.cookieDomain);
    } else {
      let cookie = this.cookieService.get('lead_referrer_string');
      let cookieParsed;

      try {
        cookieParsed = JSON.parse(cookie);
      } catch (e) {
        cookieParsed = {};
      }

      this.leadReferrerString = {
        http_referer: cookieParsed.http_referer || '',
        request_uri: cookieParsed.request_uri || '',
      }
    }
  }

  setReferrerNew() {
    if (!this.cookieService.check('lead_referrer') && !this.cookieService.check('fruRemoveCookies')) {
      const params = this.route.snapshot.queryParams;
      const source = this.scalarParam(params['utm_source']);
      const utm_content = source === 's2'
        ? this.scalarParam(params['transaction_id'])
        : '';
      this.leadReferrer = {
        source,
        medium: this.scalarParam(params['utm_medium']),
        campaign: this.scalarParam(params['utm_campaign']),
        keyword: this.scalarParam(params['utm_keyword']),
        content: this.scalarParam(params['utm_content']) || utm_content,
        network: this.scalarParam(params['network']),
        placement: this.scalarParam(params['placement']),
        gclid: this.scalarParam(params['gclid']),
        clickid: this.scalarParam(params['msclkid']),
        ttclid: this.scalarParam(params['ttclid']),
        tt_test_id: this.scalarParam(params['tt_test_id']),
        oppref: this.scalarParam(params['oppref']),
      };

      console.log('setting referrer', this.leadReferrer);

      let d = new Date();
      d.setDate(d.getDate() + 1);
      this.cookieService.set('lead_referrer', JSON.stringify(this.leadReferrer), d, '/', this.cookieDomain);
      console.log('Cookie set:', this.cookieService.get('lead_referrer'));
    } else {
      let cookie = this.cookieService.get('lead_referrer');
      let cookieParsed;

      try {
        cookieParsed = JSON.parse(cookie);
      } catch (e) {
        cookieParsed = {};
      }

      this.leadReferrer = {
        source: this.scalarParam(cookieParsed.source),
        medium: this.scalarParam(cookieParsed.medium),
        campaign: this.scalarParam(cookieParsed.campaign),
        keyword: this.scalarParam(cookieParsed.keyword),
        content: this.scalarParam(cookieParsed.content),
        network: this.scalarParam(cookieParsed.network),
        placement: this.scalarParam(cookieParsed.placement),
        gclid: this.scalarParam(cookieParsed.gclid),
        clickid: this.scalarParam(cookieParsed.clickid),
        ttclid: this.scalarParam(cookieParsed.ttclid),
        tt_test_id: this.scalarParam(cookieParsed.tt_test_id),
        oppref: this.scalarParam(cookieParsed.oppref),
      };
    }

    if (!this.cookieService.check('lead_referrer_string') && !this.cookieService.check('fruRemoveCookies')) {
      this.leadReferrerString = DefaultLeadReferrerString;
      let d = new Date();
      d.setDate(d.getDate() + 1);
      this.cookieService.set('lead_referrer_string', JSON.stringify(this.leadReferrerString), d, '/', this.cookieDomain);
    } else {
      let cookie = this.cookieService.get('lead_referrer_string');
      let cookieParsed;

      try {
        cookieParsed = JSON.parse(cookie);
      } catch (e) {
        cookieParsed = {};
      }

      this.leadReferrerString = {
        http_referer: cookieParsed.http_referer || '',
        request_uri: cookieParsed.request_uri || '',
      };
    }
  }

  setClickId() {
    let d = new Date();
    d.setHours(24, 0, 0, 0);

    if (this.route.snapshot.queryParams['click_id']) {
      this.cookieService.set('click_id', this.scalarParam(this.route.snapshot.queryParams['click_id']), d, '/', this.cookieDomain);
    }

    if (this.route.snapshot.queryParams['utm_term']) {
      this.cookieService.set('utm_term', this.scalarParam(this.route.snapshot.queryParams['utm_term']), d, '/', this.cookieDomain);
    }
  }

  getAdnetwork(): string {
    let adnetwork = '';

    // Get things from the query string
    this.route.queryParams.subscribe(params => {
      // Check for adnetwork in query string
      if (params.adnetwork) {
        adnetwork = this.scalarParam(params.adnetwork);
      } else {
        // Check for adnetwork in cookie
        let a: string = this.cookieService.get('lead_referrer');

        if (a) {
          // See if the cookie is new style
          try {
            let ad: LeadReferrer = JSON.parse(a);
            if (ad.source) {
              adnetwork = this.scalarParam(ad.source);
            }
          } catch (e) {
            // Old style cookie?
            try {
              adnetwork = atob(a);
              Sentry.captureMessage('Old style adnetwork cookie');
            } catch (err) {
              // Just don't set adnetwork
              Sentry.captureMessage('Unparseable adnetwork cookie');
            }
          }
        }
      }

      if (isDevMode()) {
        console.log('Using adnetwork', adnetwork);
      }
    });

    return adnetwork;
  }

  private scalarParam(value: unknown): string {
    if (Array.isArray(value)) {
      return this.scalarParam(value[0]);
    }

    if (value === null || value === undefined) {
      return '';
    }

    if (typeof value === 'string') {
      return value;
    }

    if (typeof value === 'number' || typeof value === 'boolean') {
      return String(value);
    }

    return '';
  }
}
